import api from './index';
import publicApi from './publicApi';
import axios from 'axios';
import axiosInstance from './index';

const toCamel = (obj) => ({
  ...obj,
  companyName: obj.company_name,
  isPublished: obj.is_published,
});

const toSnake = (obj) => ({
  ...obj,
  company_name: obj.companyName,
  is_published: obj.isPublished,
});

export const fetchCards = async () => {
  const response = await api.get('/cards/mine');
  return response.data;
};

export const fetchAllCards = async () => {
  const response = await api.get('/cards/');
  return response.data;
};

export const fetchPublicCard = async (slug) => {
  const response = await publicApi.get(`/cards/public/${slug}`);
  return response.data;
};

export const fetchCardDetails = async (slug) => {
  const response = await api.get(`/cards/edit/${slug}`);
  return response.data;
};

export const createCard = async (cardData) => {
  const response = await api.post('/cards/', cardData);
  return response.data;
};

export const updateCard = async (slug, cardData) => {
  const response = await api.put(`/cards/edit/${slug}`, cardData);
  return response.data;
};

export const uploadCardImage = async (cardSlug, fieldName, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/cards/upload-image/${cardSlug}?field_name=${fieldName}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadGalleryImage = async (cardSlug, file, caption = '') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('caption', caption);
  const response = await api.post(`/cards/upload-gallery-image/${cardSlug}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadAchievementImage = async (cardSlug, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/cards/upload-achievement-image/${cardSlug}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadAchievementPdf = async (cardSlug, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/cards/upload-achievement-pdf/${cardSlug}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadAchievementVideo = async (cardSlug, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/cards/upload-achievement-video/${cardSlug}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteCard = async (cardId) => {
  const response = await api.delete(`/cards/${cardId}`);
  return response.data;
}; 